import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQ_GROUPS } from "@/lib/constants";

export default function Faqs() {
  return (
    <section id="faqs" data-testid="faqs-section" className="bg-[#EBEBFA]">
      <div className="max-w-3xl mx-auto px-6 md:px-10 py-16 md:py-24">
        <h2 className="text-3xl md:text-4xl text-[#1A243B] mb-2">Homeschool Testing FAQs</h2>
        <p className="font-display italic text-xl text-[#2D3748]/80 mb-12">Oregon &amp; Washington</p>

        {FAQ_GROUPS.map((group, gi) => (
          <div key={group.category} className="mb-12" data-testid={`faq-group-${gi}`}>
            <h3 className="text-sm font-bold tracking-widest uppercase text-[#2D3748]/70 mb-4">{group.category}</h3>
            <Accordion type="single" collapsible className="space-y-4">
              {group.items.map((f, i) => (
                <AccordionItem
                  key={f.q}
                  value={`faq-${gi}-${i}`}
                  data-testid={`faq-item-${gi}-${i}`}
                  className="bg-white rounded-2xl border-none px-6 shadow-sm"
                >
                  <AccordionTrigger data-testid={`faq-trigger-${gi}-${i}`} className="text-left font-display text-lg text-[#1A243B] hover:no-underline py-5">
                    {f.q}
                  </AccordionTrigger>
                  <AccordionContent data-testid={`faq-content-${gi}-${i}`} className="text-[#2D3748] text-base leading-relaxed pb-6">
                    {f.bullets && (
                      <ul className="list-disc pl-5 space-y-1.5 mb-3">
                        {f.bullets.map((b) => <li key={b}>{b}</li>)}
                      </ul>
                    )}
                    {f.a && <p>{f.a}</p>}
                  </AccordionContent>
                </AccordionItem>
              ))}
            </Accordion>
          </div>
        ))}

        <div className="border-t border-[#1A243B]/10 pt-8 flex flex-col sm:flex-row sm:items-center gap-4" data-testid="faq-footer">
          <p className="font-display text-xl text-[#1A243B]">Still have questions?</p>
          <div className="flex items-center gap-5">
            <a data-testid="faq-contact-link" href="#contact" className="text-[#1A243B] font-bold underline underline-offset-4 decoration-[#FFC107] decoration-2 hover:opacity-70 transition-opacity">
              Contact Julie
            </a>
            <span className="text-[#2D3748]/40">·</span>
            <a data-testid="faq-book-link" href="#book" className="text-[#1A243B] font-bold underline underline-offset-4 decoration-[#FFC107] decoration-2 hover:opacity-70 transition-opacity">
              Schedule testing →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
